import React, { useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'
import {
  // IncidentsDummyData,

  policyHeader,
  UserssHeaders,
} from '../../data/index'

import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import Pagination from '../../components/UI/Pagination'
import '../../App.css'
import { useQuery } from 'react-query'

import {
  getSuperScoolDataUser,
  getSuperUserData,
  getSuperUserRroles,
} from './apiCall'

import { toast } from 'react-toastify'
import { calculatePageCount } from '../training/utils'
import Modal from '../../components/UI/UIModal'
import UITextInput from '../../components/UI/UITextInput'
import UIButton from '../../components/UI/UIButton'

import { ErrorResponse, incidentData, User } from '../../utils/types'
import {
  createUserApi,
  createUserType,
  deleteSchoolUser,
  resendVerificationEmail,
  updateUserApi,
} from '../../api/super/Users'

import Menu from '../../components/UI/UIMenu'
import UiSelectSchool from './components/UISelectSchool'
import { removeNullEntries } from '../../utils/utils'
import UiSelect from '../../components/UI/UISelect'
import UISwitch from '../../components/UI/UISwitch'

const initialData = {
  firstName: '',
  lastName: '',
  // type: 'school',
  role: '',
  email: '',
  sendInvitationEmail: true,
}
const Users = () => {
  const [isView, setIsView] = useState(false)
  const [sId, setSid] = useState('')
  const [userId, setUserId] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [userData, setUserData] = useState<createUserType>(initialData)
  const [isEdit, setIsEdit] = useState(false)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const handleCloseModal = () => {
    setIsOpen(false)
  }
  const handleOpenModal = () => {
    setIsEdit(false)
    setIsOpen(true)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  const handleChange = (fieldName: string, value: string | boolean): void => {
    setUserData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
    // You can add additional logic here, like fetching data for the new page
  }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const getSchools = useQuery('schools', () => getSuperScoolDataUser())
  const getRoles = useQuery('roles', () => getSuperUserRroles())

  const getUsers = useQuery('users', () => getSuperUserData(currentPage))
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(getUsers?.data?.data?.length || 100).fill(false)
  )

  //   const statusBgColor = (status: string): string => {
  //     switch (status) {
  //       case 'Published':
  //         return 'lightGreen'
  //       case 'Lapsed':
  //         return 'paleYellow'
  //       case 'Not Active':
  //         return 'palePink'
  //       default:
  //         return 'gray3'
  //     }
  //   }

  console.log(getSchools)

  const convertedData = getSchools?.data?.data?.map((item) => ({
    value: item.id,
    label: item.name,
    address: item.addressLineOne,
  }))
  const convertedDataRoles = getRoles?.data?.map((item) => ({
    value: item.id,
    label: item.role,
  }))

  const handleSwitchChange = (value: boolean) => {
    // setSwitchValue(value)
    handleChange('sendInvitationEmail', value)
  }

  const createUser = async (): Promise<void> => {
    try {
      const response = (await createUserApi(userData, sId)) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        getSchools.refetch()
        handleCloseModal()
        setIsView(false)
        toast.success('User Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const resendEmail = async (schoolId: string, uid: string): Promise<void> => {
    try {
      const response = (await resendVerificationEmail(schoolId, uid)) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        getSchools.refetch()
        handleCloseModal()
        setIsView(false)
        toast.success('Email Sent', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const editUser = async (): Promise<void> => {
    try {
      const response = (await updateUserApi(
        removeNullEntries(userData) as createUserType,
        sId,
        userId
      )) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        setIsEdit(false)
        setUserData(initialData)
        getUsers.refetch()
        handleCloseModal()
        setIsView(false)

        toast.success('Group Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const removeSchool = async (): Promise<void> => {
    console.log(sId, userId)
    try {
      const response = (await deleteSchoolUser({ id: sId, uid: userId })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        getUsers.refetch()
        setIsEdit(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  useEffect(() => {
    getUsers.refetch()
  }, [currentPage])

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-10 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Users</p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Please add your incidents here. You can give various reasons and
                solutions, and specify their severity level.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              {/* <div className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer ">
                <p className={'font-medium text-[14px] text-text1'}>
                  Export Data
                </p>
                <Icon
                  name={'exportIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}

              <div
                onClick={handleOpenModal}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create User
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>

          {/* content container */}
          <>
            <div
              id={'#container'}
              className="w-full flex justify-center items-center"
            >
              {/* table component */}

              <div className="overflow-hidden rounded-[16px] w-full">
                <table className="rounded-[16px] overflow-hidden border w-full border-white">
                  <thead>
                    <tr className="bg-gray2 cursor-pointer">
                      {UserssHeaders?.map((item, index: number) => {
                        return (
                          <th
                            key={index}
                            className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                          >
                            <div className="flex items-center">
                              <p className="text-text1 font-semibold text-sm flex-1">
                                {item.replace(/_/g, ' ')}
                              </p>
                              <div onClick={() => console.log('check')}>
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        )
                      })}
                      <th className="w-1/8 px-4 py-3 border text-left border-white"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {getUsers?.data?.data?.map((item, index) => (
                      <>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.no}
                          </td>
                          <td className="px-4 w-[200px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.firstName} {item.lastName}
                          </td>
                          <td className="px-4 w-[200px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.email}
                          </td>

                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <div className="px-[10px] flex justify-center items-center bg-lightGreen h-[28px] rounded-[100px]">
                              <p className="text-xs font-medium leading-5 text-text2">
                                {item.status}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 w-[200px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.role}
                          </td>
                          <td className="px-4 w-[200px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.createdAt?.substring(0, 16)}
                          </td>
                          <td className="px-4 w-[200px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.schoolName}
                          </td>

                          <td className="px-4 items-center justify-center flex   h-[48px] py-2 border border-white">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'Edit',
                                  onClick: () => {
                                    handleOpenModal()
                                    setIsEdit(true)
                                    setSid(item.schoolId)
                                    setUserId(item.userId)
                                    setUserData({
                                      firstName: item.firstName,
                                      lastName: item.lastName,
                                      // type: 'school',
                                      role: item.roleId,
                                      sendInvitationEmail:
                                        item.sendInvitationEmail,
                                      // email: null,
                                    })
                                    handleToggleMenu(index)
                                  },
                                  icon: 'IconEdit',
                                  iconColor: '',
                                },
                                {
                                  display:
                                    item.status == 'inactive' ? true : false,
                                  label: 'Re-send email',
                                  onClick: () => {
                                    resendEmail(item.schoolId, item.userId)

                                    // setIsOpenDeleteUserModal(true)
                                    // setSchoolItemId(item.schoolId)
                                  },
                                  icon: 'IconMail',
                                  iconColor: '#02698C',
                                },
                                {
                                  label: 'Remove',
                                  onClick: () => {
                                    setSid(item.schoolId),
                                      setUserId(item.userId),
                                      setIsOpenDelete(true)
                                  },
                                  icon: 'IconTrash',
                                  iconColor: '#FF6666',
                                  textColor: 'text-textError',
                                },
                              ]}
                              type={'table'}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div
                                onClick={() => {
                                  handleToggleMenu(index)
                                }}
                              >
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>

          <div className="absolute bottom-4">
            {/* Your content here */}

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(getUsers?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      )}
      {isView && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            mainPage="Schools"
            subPage=""
            copy="Here you can edit and manage the Schools"
            onCreate={() => {
              //   handleOpenModal()
              //   setIsEdit(false)
            }}
            // onPublish={}
            onEdit={() => {
              //   handleOpenModal()
              //   setIsEdit(true)
            }}
            onDelete={() => {
              //   setIsOpenDelete(true)
            }}
            isViewMode={true}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    File
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="bg-white w-[268px] h-[48px] flex justify-center items-center">
                      <p>name of file.pdf</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="px-[20px] rounded-[72px] w-fit py-[10px] bg-lightGreen flex justify-center items-center">
                      <p>Published</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Create at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Jan 29, 2024, 4:42:47 PM
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Jan 29, 2024, 4:42:47 PM
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>
            Further Information
          </p>

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    File
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="bg-white w-[268px] h-[48px] flex justify-center items-center">
                      <p>name of file.pdf</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="px-[20px] rounded-[72px] w-fit py-[10px] bg-lightGreen flex justify-center items-center">
                      <p>Published</p>
                    </div>
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          {/* modal */}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>Create User</h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details for User
            </p>
          </div>

          {/* other information */}
          <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
            <div>
              <UITextInput
                label={'First Name'}
                onChange={(e) => {
                  handleChange('firstName', e.target.value)
                }}
                value={userData.firstName}
                placeholder="Please enter first name"
                iconName={''}
              />
            </div>
            <div>
              <UITextInput
                label={'Last Name'}
                onChange={(e) => {
                  handleChange('lastName', e.target.value)
                }}
                value={userData.lastName}
                placeholder="Please enter last name"
                iconName={''}
              />
            </div>
            {isEdit == false && (
              <>
                <div>
                  <UITextInput
                    label={'Email'}
                    onChange={(e) => {
                      handleChange('email', e.target.value)
                    }}
                    value={userData.email}
                    placeholder="Please enter your Email"
                    iconName={''}
                  />
                </div>
                <div>
                  <UiSelectSchool
                    options={convertedData || []}
                    title={'Select School'}
                    onChange={(e) => {
                      setSid(e)
                    }}
                    value={userData.role}
                  />
                </div>
                <div>
                  <UiSelect
                    options={convertedDataRoles || []}
                    title={'Select Role'}
                    onChange={(e) => {
                      handleChange('role', e)
                    }}
                    value={userData.role}
                  />
                </div>

                <div className="w-full p-4 bg-gray1 rounded-xl flex">
                  <div className="flex-1">
                    <p className="text-sm font-semibold leading-6 text-text4">
                      Verification Email
                    </p>
                    {/* <p className="text-sm font-normal leading-6 text-text3">
                      Sends email reminders when certain records are near expiry
                      date.
                    </p> */}
                  </div>
                  <div>
                    <UISwitch
                      value={userData?.sendInvitationEmail}
                      onValueChange={handleSwitchChange}
                    />
                  </div>
                </div>
              </>
            )}

            <UIButton
              onClick={isEdit ? editUser : createUser}
              type="submit"
              label={isEdit ? 'Update' : 'create'}
            />
          </div>
        </div>
      </Modal>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>Delete User</h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this User?
            </p>
          </div>

          <button
            onClick={() => {
              removeSchool()
              setIsView(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            // onClick={}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Users
